import React from 'react';
import styled from 'styled-components';


const Main = styled.main`
  display: table;
  width: 100%;
  height: 100vh;
  text-align: center;
`;

const FOF = styled.div`
  @keyframes type{
      from{box-shadow: inset -3px 0px 0px #888;}
      to{box-shadow: inset -3px 0px 0px transparent;}
}

  display: table-cell;
  vertical-align: middle;

  h1 {
    font-size: 50px;
    display: inline-block;
    padding-right: 12px;
    animation: type .5s alternate infinite;
  }
`;

function PageNotFound() {
  return (
    <Main>
      <FOF>
            <h1>Not Found 404</h1>
      </FOF>
    </Main>
  )
}

export default PageNotFound;